import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialAdditionalDocApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import React from "react";
import { AdditionalDocApplication } from "../types/additionalDocTypes";
import { initialAdditionalDocDetail } from "./rudiAdditionalDocInitialValues";
import RegprofAdditionalDocStepApplicant from "../views/components/services/additionalDoc/form/applicant/RegprofAdditionalDocStepApplicant";
import RegprofAdditionalDocStepDetails from "../views/components/services/additionalDoc/form/detail/RegprofAdditionalDocStepDetails";
import RegprofAdditionalDocStepDocuments from "../views/components/services/additionalDoc/form/documents/RegprofAdditionalDocStepDocuments";
import RegprofAdditionalDocStepFiling from "../views/components/services/additionalDoc/form/filing/RegprofAdditionalDocStepFiling";

export const initialRegprofAdditionalDocApplication: AdditionalDocApplication = {
  additionalDocDetail: initialAdditionalDocDetail,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialAdditionalDocApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <RegprofAdditionalDocStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.additionalDoc.details",
      completed: false,
      component: <RegprofAdditionalDocStepDetails />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <RegprofAdditionalDocStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <RegprofAdditionalDocStepFiling />,
      isEdited: false,
    },
  ],
};
